export default {
  HOME: { circleId: 1, circleName: '广场'},
  HTML_MATERIAL: { circleId: 2, circleName: '素材'},
}
